import type { ReactNode } from 'react';
import { Text } from '@fluentui/react-components';

/** Título único de página (h1) — mismo tamaño y peso en todo el dashboard. */
export function PageTitle({ children }: { children: ReactNode }) {
  return <Text as="h1" size={600} weight="semibold" block>{children}</Text>;
}
